import React, { useEffect, useState, useRef  } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import api from "../services/api";
import BaseLayout from "../layouts/BaseLayout";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

function Orders() {
  const [loading, setLoading] = useState(true);
  const { slug } = useParams();
  const navigate = useNavigate();
  const hasFetched = useRef(false);
  const [restaurant, setRestaurant] = useState(null);
  const [banners, setRestaurantBanner] = useState([]);
  const [categories, setCategories] = useState([]);
  const [activeTab, setActiveTab] = useState(null);
  const sectionRefs = useRef({});
  const tabsContainerRef = useRef(null);
  const tabRefs = useRef({});
  const [search, setSearch] = useState("");
  const [cart, setCart] = useState(()=>{
    const savedCart = localStorage.getItem("cart");
    return savedCart ? JSON.parse(savedCart) : [];
  });
  const [showCart, setShowCart] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null); // for popup
  const [note, setNote] = useState("");

  

  // Fetch categories
  useEffect(() => {

    localStorage.setItem("cart", JSON.stringify(cart));
    if (!slug) return; // stop API call
    
    if (hasFetched.current) return;

    hasFetched.current = true;
    fetchData();
    //fetchData();
  }, [cart]);

  const fetchData = async () => {
    try {
      const res = await api.get(`/restaurant/${slug}`);
      setRestaurant(res.data.restaurant);
      setRestaurantBanner(res.data.restaurantBanner);
      setCategories(res.data.categories);
      if (res.data.length > 0) setActiveTab(res.data.categories[0].id);
    } catch (err) {
      navigate("/404");
    } finally {
      setLoading(false);
    }      
  };

  const filterItems = (items) => {
    if (!search) return items;

    return items.filter(item =>
      (item.item_name || "")
        .toLowerCase()
        .includes(search.toLowerCase())
    );
  };

  // Scroll to section on tab click
  const scrollToCategory = (id) => {
    const section = sectionRefs.current[id];
    if (section) {
      window.scrollTo({
        top: section.offsetTop - 100,
        behavior: "smooth",
      });
      setActiveTab(id);
    }
  };

  const openPopup = (item) => {
    setSelectedItem(item);
    setNote(""); // reset note
  };

  // Update active tab on scroll and move tab into view
  useEffect(() => {
    const handleScroll = () => {
      let current = activeTab;

      categories.forEach((cat) => {
        const section = sectionRefs.current[cat.id];
        if (section) {
          const rect = section.getBoundingClientRect();
          if (rect.top <= 150 && rect.bottom >= 150) {
            current = cat.id;
          }
        }
      });

      if (current !== activeTab) {
        setActiveTab(current);

        // Scroll the tab into view
        const tabEl = tabRefs.current[current];
        if (tabEl && tabsContainerRef.current) {
          const containerRect = tabsContainerRef.current.getBoundingClientRect();
          const tabRect = tabEl.getBoundingClientRect();

          // If tab is out of view, scroll the container
          if (tabRect.left < containerRect.left || tabRect.right > containerRect.right) {
            tabsContainerRef.current.scrollBy({
              left: tabRect.left - containerRect.left - containerRect.width / 2 + tabRect.width / 2,
              behavior: "smooth",
            });
          }
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [categories, activeTab]);

  const addToCart = (item,type,note=null) => {
    setCart((prevCart) => {

      const existing = prevCart.find(i => i.id === item.id);
      
      if (existing) {
        
          if (type=="inc"){
            return prevCart.map(i =>
              i.id === item.id ? { ...i, qty: i.qty + 1,note } : i
            );
          }
          else{
            if (!existing) return prevCart;

            const newQty = existing.qty - 1;

            // ❌ REMOVE if qty becomes 0
            if (newQty <= 0) {
              return prevCart.filter(i => i.id !== item.id);
            }

            // ✅ Otherwise decrease qty
            return prevCart.map(i =>
              i.id === item.id ? { ...i, qty: newQty, note } : i
            );
              
          }
        
      }

      return [...prevCart, { ...item, qty: 1, note }];
    });
  };
  const clearCart = () => {
    setCart([]); // empty the cart state
    localStorage.removeItem("cart"); // remove from localStorage
  };
  const getCartItem = (id) => cart.find((i) => i.id === id);
  const getQty = (id) => getCartItem(id)?.qty || 0;

  return (
    <BaseLayout restaurant={restaurant} loading={loading}>
      <section className="py-0">
        <Swiper  spaceBetween={10} slidesPerView={1} autoplay={{ delay: 3000 }}>
          {banners.map(banner => (
            <SwiperSlide>
              <img
                src={`${process.env.REACT_APP_STORAGE_URL}${banner.image}`}
                alt={banner.title}
                style={{
                  width:"100%",
                }}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </section>

      <section className="pt-2 overflow-hidden">
        {/* Search Filter */}
        <div className="container">
          <form role="search" action="index.html" method="get" className="d-flex mt-3 gap-0">
            <input className="form-control rounded-start rounded-0 bg-light" type="email" placeholder="What are you looking for?" aria-label="What are you looking for?" value={search}
            onChange={(e) => setSearch(e.target.value)} />
            <button className="btn btn-dark rounded-end rounded-0" type="submit">Search</button>
          </form>
        </div>
      </section>
      
      
      
        <div className="container">
          {/* Category Tabs */}
          <div
            className={`categories border-bottom`}
            ref={tabsContainerRef}
            style={{
              display: "flex",
              overflowX: "auto",
              padding: "10px 0",
              gap: "10px",
              background: "#fff",
              borderBottom: "1px solid #eee",
              position: "sticky",
              top: 0,
              zIndex: 1000,
            }}
          >
            {categories.map((cat) => (
              <button
                key={cat.id}
                ref={(el) => (tabRefs.current[cat.id] = el)}
                onClick={() => scrollToCategory(cat.id)}
                style={{
                  border: "none",
                  cursor: "pointer",
                  background: activeTab === cat.id ? "#000000" : "#eee",
                  color: activeTab === cat.id ? "#fff" : "#000",
                  flexShrink: 0,
                  textTransform:"Uppercase",
                  fontWeight:500,
                }}
                className={`btn btn-dark rounded `}
              >
                {cat.category_name}
              </button>
            ))}
          </div>

          {/* Category Items */}
          <div >
            {categories.map((cat) => {
              const filteredItems = filterItems(cat.items || []);
              if (filteredItems.length === 0) return null;
              return (
                <div
                  key={cat.id}
                  ref={(el) => (sectionRefs.current[cat.id] = el)}
                  style={{  borderBottom: "1px solid #eee" }}
                >
                  <p className="text-dark font-weight-bold text-uppercase">{cat.category_name}</p>
                  {filteredItems.map(item => {
                    const cartItem = cart.find(i => i.id === item.id);
                    const isInCart = !!cartItem;
                    const qty = cartItem?.qty || 0;
                    return(
                    <div className="col px-0" key={item.id} style={{ cursor: "pointer" }}
                      onClick={() => openPopup(item)}>
                        <div className="product-item"
                        style={{
                          border: qty > 0 ? "1px solid green": "",
                          cursor: "pointer",
                        }}
                        >
                          
                          <span className="d-none badge bg-success position-absolute m-3" style={{right:0}}>-30%</span>
                          <div className="text-start">
                            <h6 className="title">{item.item_name}</h6>
                            <span className="rating d-none">
                            <svg width="24" height="24" className="text-primary"><use xlinkHref="#star-solid"></use></svg>
                            4.5</span>
                            <p className="mb-0">{item.description?.substring(0, 35)}..</p>
                            
                            <div className="d-flex align-items-center justify-content-between">
                              <div><span className="price">{item.price}AED</span></div>
                              <div className="input-group product-qty">
                                

                              
                                {qty > 0 && (
                                  <span className="input-group-btn">
                                      <button type="button" className="quantity-left-minus btn btn-danger btn-number" data-type="minus"
                                        onClick={(e) => {
                                          e.stopPropagation(); // prevent modal open
                                          addToCart(item,"dec");
                                        }}
                                        >
                                        <svg width="16" height="16"><use xlinkHref="#minus"></use></svg>
                                      </button>
                                  </span>
                                )}
                                {qty > 0 && (
                                <input type="text" value={qty} readOnly className="form-control text-center"  />
                                )}
                                <span className="input-group-btn">
                                  <button type="button" className="quantity-right-plus btn btn-success btn-number" data-type="plus"
                                    onClick={(e) => {
                                      e.stopPropagation(); // prevent modal open
                                      addToCart(item,"inc");
                                    }} >
                                    <svg width="16" height="16"><use xlinkHref="#plus"></use></svg>
                                  </button>
                                </span>
                                
                              </div>
                            </div>
                          </div>
                          <figure className="mb-0" style={{display: "flex",justifyContent: "center",alignItems: "center"}}>
                            <a title="Product Title">
                            {item.image && (
                              <img
                                src={`${process.env.REACT_APP_STORAGE_URL}${item.image}`}
                                alt={item.item_name}
                                className="tab-image"
                              />
                            )}
                            </a>
                          </figure>
                        </div>
                      </div>
                    );
                  })}
                </div>
                );
            })}
            
            {/* Modal */}
            {selectedItem && (
              
              <div 
                className="modal fade show d-block itemPopup" 
                tabIndex="-1" 
                style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
                onClick={() => setSelectedItem(null)}
              >
                <div 
                  className="modal-dialog modal-dialog-centered" 
                  onClick={e => e.stopPropagation()} // prevent closing when clicking inside
                >
                  <div className="modal-content p-3">
                    <div className="modal-header">
                      <h5 className="text-dark modal-title">{selectedItem.item_name}</h5>
                      <button 
                        type="button" 
                        className="btn-close" 
                        onClick={() => setSelectedItem(null)}
                      ></button>
                    </div>
                    <div className="modal-body">
                      {selectedItem.image && (
                        <img
                          src={`${process.env.REACT_APP_STORAGE_URL}${selectedItem.image}`}
                          alt={selectedItem.item_name}
                          className="tab-image"
                        />
                      )}
                      <p className="text-dark">{selectedItem.description}</p>
                      <textarea
                        placeholder="Add extra note (e.g. no spicy, extra cheese)"
                        value={note}
                        onChange={(e) => setNote(e.target.value)}
                        className="fonr-control w-100 rounded p-2"
                      />
                      <div className="d-flex align-items-center justify-content-between">
                        <div><span className="price"><strong>Price:</strong> {selectedItem.price}AED</span></div>
                        <div className="product-qty">
                        {/* CART CONTROLS */}
                          {(() => {
                            const qty = getQty(selectedItem.id);

                            return (
                              <div className="d-flex justify-content-center mt-3">
                                {qty === 0 ? (
                                  <button
                                    className="btn btn-dark rounded "
                                    onClick={() =>
                                      addToCart(selectedItem, "inc",note)
                                    }
                                  >
                                    Add
                                  </button>
                                ) : (
                                  <div className="d-flex align-items-center gap-3">
                                    <button
                                      className="btn btn-dark rounded"
                                      onClick={() =>
                                        addToCart(selectedItem, "dec",note)
                                      }
                                    >
                                      -
                                    </button>

                                    <span className="fw-bold">{qty}</span>

                                    <button
                                      className="btn btn-dark rounded"
                                      onClick={() =>
                                        addToCart(selectedItem, "inc",note)
                                      }
                                    >
                                      +
                                    </button>
                                  </div>
                                )}
                              </div>
                            );
                          })()}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="cart-box p-3 border-top">
          <button className="btn btn-dark rounded" type="submit"  onClick={() => setShowCart(true)} ><i className="bi bi-cart-fill"></i> ({cart.length})</button>

          {/* {cart.map((item) => (
            <div key={item.id} className="d-flex justify-content-between">
              <span>{item.item_name} x {item.qty}</span>
              <span>{item.price * item.qty} AED</span>
            </div>
          ))}

          {cart.length > 0 && (
            <h6 className="mt-2">
              Total:{" "}
              {cart.reduce((sum, i) => sum + i.price * i.qty, 0)} AED
            </h6>
          )} */}
        </div>
        
      {showCart && (
  <div
    className="modal fade show d-block"
    style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    onClick={() => setShowCart(false)}
  >
    <div
      className="modal-dialog modal-dialog-centered"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="modal-content p-3">

        {/* Header */}
        <div className="modal-header p-0">
          {/* <h4 className="text-dark modal-title">Your Cart</h4> */}
          <button
            className="btn-close"
            onClick={() => setShowCart(false)}
          ></button>
        </div>

        {/* Body */}
        <div className="modal-body">

          {cart.length === 0 ? (
            <p className="text-center">Cart is empty</p>
          ) : (
            <>
              {cart.map((item) => (
                <div
                  key={item.id}
                  className="d-flex justify-content-between product-item align-items-center mb-2"
                >
                  <div>
                    <h5 className="text-dark mb-0">{item.item_name}</h5>
                    {item.note && <p className="text-dark"> {item.note}</p>}
                    <strong className="text-dark">{item.price} AED</strong>
                  </div>

                  {/* Qty controls */}
                  <div className="d-flex align-items-center gap-2">
                    <button
                      className="btn btn-danger btn-number btn-sm"
                      onClick={() => addToCart(item, "dec")}
                    >
                      -
                    </button>

                    <span>{item.qty}</span>

                    <button
                      className="btn btn-success btn-number btn-sm"
                      onClick={() => addToCart(item, "inc")}
                    >
                      +
                    </button>
                  </div>
                </div>
              ))}

              {/* Total */}
              <hr />
              <h4 className="text-dark text-end">
                Total:{" "}
                {cart.reduce((sum, i) => sum + i.price * i.qty, 0)} AED
              </h4>
            </>
          )}

        </div>
        
        {/* Footer */}
        {cart.length > 0 && (
          <div className=" modal-footer">
            <button 
  className="btn btn-danger w-100 mb-2"
  onClick={clearCart}
>
  Clear All
</button>
            <button className="btn btn-success w-100">
              Proceed to Confirm
            </button>
          </div>
        )}

      </div>
    </div>
  </div>
)}



    
    </BaseLayout>
  );
}

export default Orders;